
import axios from 'axios'
import qs from 'qs'

/**
 * METHOD: POST;  CONTENT_TYPE: application/x-www-form-urlencoded
 * @param url {string}
 * @param data {Object}
 */
export function postFormData (url, data) {
  return axios.post(url, qs.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).catch(res => res)
}

/**
 * METHOD: POST;  CONTENT_TYPE: application/json
 * @param url {string}
 * @param data {Object}
 */
export function postJSON (url, data) {
  return axios.post(url, data)
}



// WEBPACK FOOTER //
// ./src/utils/request.js